import { render, staticRenderFns } from "./salesDetail.vue?vue&type=template&id=5acb1240&scoped=true"
import script from "./salesDetail.vue?vue&type=script&lang=js"
export * from "./salesDetail.vue?vue&type=script&lang=js"
import style0 from "./salesDetail.vue?vue&type=style&index=0&id=5acb1240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb1240",
  null
  
)

export default component.exports